import { useRouteMatch } from 'react-router'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SettingsPageLayout } from 'App/components/common/SettingsPageLayout'
import { TNavMenuItem } from 'App/components/common/NavMenu'
import { eventsSettingsNestedRoutes } from 'App/App.config'
import { UnityHubBackButton } from 'App/components/UnityHub/UnityHubBackButton'

import styles from './EventSettings.module.scss'

export const EventSettings = () => {
  const { params } = useRouteMatch<{ id: string }>()

  const { t } = useTranslation()

  const eventId = params.id

  const defaultPath = `/events/${eventId}/edit/basic`

  const menuList = useMemo<TNavMenuItem[]>(
    () => [
      {
        link: `/events/${eventId}/edit/basic`,
        title: t('events.settings.basicInformation')
      },
      {
        link: `/events/${eventId}/edit/branding`,
        title: t('events.settings.branding')
      },
      {
        link: `/events/${eventId}/edit/links`,
        title: t('events.settings.links')
      },
      {
        link: `/events/${eventId}/edit/attendees`,
        title: t('events.settings.attendeesInfo')
      },
      {
        link: `/events/${eventId}/edit/organizer-settings`,
        title: t('events.settings.organizerSettings')
      }
    ],
    [eventId, t]
  )

  if (!eventId) {
    return null
  }

  return (
    <div className={styles.root}>
      <UnityHubBackButton path={`/events/${eventId}`} className={styles.backButton} />
      <SettingsPageLayout
        menu={{
          menuList,
          classes: { root: styles.menu }
        }}
        defaultPath={defaultPath}
        nestedRoutes={eventsSettingsNestedRoutes}
        paper={true}
      />
    </div>
  )
}
